<template>
    <section>
        <div class="row">
            <div class="col-md-2"><p class="form-control-static">Pozycja</p></div>
            <div class="col-md-1"><p class="form-control-static">Jednostka</p></div>
            <div class="col-md-1"><p class="form-control-static">Ilość</p></div>
            <div class="col-md-1"><p class="form-control-static">Z magazynu</p></div>
            <div class="col-md-2"><p class="form-control-static">Na magazyn</p></div>
            <div class="col-md-2"><p class="form-control-static">Dla wyprod.</p></div>
            <div class="col-md-1"><p class="form-control-static">Uwagi</p></div>
            <div class="col-md-1"><p class="form-control-static">Godzina</p></div>
        </div>
        <div class="row">
            <div class="col-md-2">
                <singleselect
                        v-model="material"
                        :checked="shiftModel.material"
                        name="materials"
                        :options="materials"
                        :allow-empty="false"
                >
                </singleselect>
            </div>
            <div class="col-md-1">
                <span>{{ materialUnit }}</span>
            </div>
            <div class="col-md-1">
                <input
                    v-model="quantity"
                    :disabled="!material"
                    :step="step"
                    style="width:100px;"
                    class="form-control"
                    min="0"
                    type="number"
                    @keyup="updateQuantity"
                />
            </div>
            <div class="col-md-1">
                <singleselect
                        v-model="warehouseFrom"
                        :checked="shiftModel.warehouseFrom"
                        name="warehouse-from"
                        :options="warehousesFrom"
                        :allow-empty="false"
                >
                </singleselect>
            </div>
            <div class="col-md-2">
                <singleselect
                        v-model="warehouseTo"
                        :checked="shiftModel.warehouseTo"
                        name="warehouse-to"
                        :options="warehousesTo"
                        :allow-empty="false"
                        :placeholder="'Wybierz magazyn'"
                >
                </singleselect>
            </div>
            <div class="col-md-2">
                <singleselect
                        v-model="meal"
                        name="meal"
                        :checked="shiftModel.meal"
                        :options="meals"
                        :allow-empty="false"
                >
                </singleselect>
            </div>
            <div class="col-md-1">
                <input v-model="description" style="width:100px;" class="form-control" type="text"/>
            </div>
            <div class="col-md-1">
                <date-picker v-model="expectedDate" input-class="form-control" :config="dateOptions"></date-picker>
            </div>
            <div class="col-md-1">
                <div class="btn btn-danger btn-block" @click="deleteRow"><b>Usuń</b></div>
            </div>
        </div>
        <div v-if="hasErrors" style="color:red;" class="row">
            <div class="col-md-2"><p class="form-control-static">{{getError('material')}}</p></div>
            <div class="col-md-1"><p class="form-control-static">{{getError('unit')}}</p></div>
            <div class="col-md-1"><p class="form-control-static">{{getError('amountExpected')}}</p></div>
            <div class="col-md-1"><p class="form-control-static">{{getError('warehouseFrom')}}</p></div>
            <div class="col-md-2"><p class="form-control-static">{{getError('warehouseTo')}}</p></div>
            <div class="col-md-2"><p class="form-control-static">{{getError('meal')}}</p></div>
            <div class="col-md-1"><p class="form-control-static">{{getError('description')}}</p></div>
            <div class="col-md-1"><p class="form-control-static">{{getError('dateExpected')}}</p></div>
        </div>
        <div v-if="hasClassErrors" style="color:red;" class="row">
            <div v-for="(error, index) in classErrors" :key="index" class="col-md-12">
                <p class="form-control-static">{{error}}</p>
            </div>
        </div>
    </section>
</template>

<script>
/* eslint-disable vue/no-mutating-props */
import datePicker from 'vue-bootstrap-datetimepicker'
import Singleselect from '../../component/simple-form/singleselect.vue'

export default {
  name: 'QuickWarehouseShift',
  components: {
    datePicker,
    Singleselect,
  },
  props: {
    materials: {
      type: Array,
      default: () => [],
    },
    warehouses: {
      type: Array,
      default: () => [],
    },
    meals: {
      type: Array,
      default: () => [],
    },
    shiftModel: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      dateOptions: {
        format: 'HH:mm',
        useCurrent: true
      },
      expectedDate: this.shiftModel.dateExpected,
      warehouseFrom: null,
      warehouseTo: null,
      quantity: this.shiftModel.amountExpected,
      description: this.shiftModel.description,
      material: null,
      meal: null,
      step: 1,
      product: null,
      errors: null,
    }
  },
  computed: {
    classErrors: function () {
      let errors = this.shiftModel.errors || {}
      let errArray = []
      for (let field in errors) {
        if (typeof errors[field] !== 'object') {
          errArray.push(errors[field])
        }
      }
      return errArray
    },
    materialUnit: function () {
      if (isNaN(this.material)) {
        return ''
      }
      let material = this.materialModel
      if (material) {
        switch (material.unit) {
          case 'piece':
            return 'szt.'
          case 'mass':
            return 'kg'
          default:
            return material.unit
        }
      }
      return ''
    },
    materialModel: function () {
      if (isNaN(this.material)) {
        return null
      }
      return this.materials.find(material => {
        return material.id === this.material
      })
    },
    warehousesFrom: function () {
      return this.warehouses.filter((warehouse) => {
        return warehouse.supply === true
      })
    },
    warehousesTo: function () {
      if (!this.warehouseFrom) {
        return []
      }

      let warehouseFrom = this.warehouses.find(warehouseFrom => warehouseFrom.id === this.warehouseFrom)
      return this.warehouses.filter((warehouse) => {
        return warehouse.isVirtual && warehouse.hasTeam && warehouseFrom.supplyTeamsIds.includes(warehouse.teamId)
      })
    },
  },
  watch: {
    product: function (newProduct) {
      if (newProduct) {
        this.shiftModel.unitWeight = this.product.weight
        this.shiftModel.unit = this.product.unit
      }
    },
    material: function (newMaterial) {
      if (isNaN(newMaterial)) {
        return
      }
      this.shiftModel.material = newMaterial
      if (this.materialUnit === 'kg') {
        this.quantity = Math.round(this.quantity * 100) / 100
        this.step = 0.01
      } else {
        this.quantity = Math.round(this.quantity)
        this.step = 1
      }
      let model = this.materialModel
      if (model) {
        this.product = model.products[0] || null
      }
    },
    warehouseFrom: function (newWarehouseFrom) {
      if (isNaN(newWarehouseFrom)) {
        return
      }
      this.shiftModel.warehouseFrom = newWarehouseFrom
      this.shiftModel.warehouseTo = null
    },
    warehouseTo: function (newWarehouseTo) {
      if (isNaN(newWarehouseTo)) {
        return
      }
      this.shiftModel.warehouseTo = newWarehouseTo
    },
    quantity: function (newQuantity) {
      if (isNaN(newQuantity)) {
        return
      }
      this.shiftModel.amountExpected = parseFloat(newQuantity)
    },
    meal: function (newMeal) {
      if (isNaN(newMeal)) {
        return
      }
      this.shiftModel.meal = newMeal
    },
    expectedDate: function (newExpecedDate) {
      this.shiftModel.dateExpected = newExpecedDate.format('HH:mm')
    },
    description: function (newDescription) {
      this.shiftModel.description = newDescription
    }
  },
  methods: {
    hasErrors: function () {
      return typeof this.shiftModel.errors !== 'undefined'
    },
    hasClassErrors: function () {
      return true
    },
    removeError: function (field) {
      if (this.getError(field)) {
        delete this.shiftModel.errors[field][1]
      }
    },
    getError: function (field) {
      if (typeof this.shiftModel.errors !== 'undefined') {
        if (typeof this.shiftModel.errors[field] !== 'undefined') {
          for (let err in this.shiftModel.errors[field]) {
            return this.shiftModel.errors[field][err]
          }
        }
      }
      return null
    },
    deleteRow: function () {
      this.$emit('quickshiftdeleted')
    },
    updateQuantity($event) {
      let value = parseFloat($event.target.value)
      if (this.materialUnit === 'kg') {
        this.quantity = Math.round(value * 1000) / 1000
      } else {
        this.quantity = Math.round(value)
      }
    }
  }
}
</script>

<style scoped>

</style>
